webpackJsonp([19],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	module.exports = __webpack_require__(29);


/***/ }),

/***/ 29:
/***/ (function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(1);
	var _ = __webpack_require__(3);
	var lightbox = __webpack_require__(16)
	var gameTracking = __webpack_require__(5);
	var manualRuutuEmbed = __webpack_require__(8);
	
	var showTooltip = function () {
	    var $this = $(this);
	    $('.shooting-map-container .shot-tooltip, .shot').removeClass('active');
	    $this.addClass('active');
	    $('.tooltip-' + $this.data('tooltipid')).addClass('active');
	};
	
	var hideTooltip = function () {
	    var $this = $(this);
	    $('.shot, .tooltip-' + $this.data('tooltipid')).removeClass('active');
	};
	
	var toggleShots = function (periodSelections, eventSelections, playerId) {
	    var selectorBase = '.shot';
	    $(selectorBase).hide();
	
	    if (playerId)
	        selectorBase += '.player-' + playerId;
	
	    var periods = [];
	    _.each(periodSelections, function (enabled, period) {
	        if (enabled)
	            periods.push('.period-' + period);
	    });
	
	    var events = [];
	    _.each(eventSelections, function (enabled, eventType) {
	        if (enabled)
	            events.push('.event-' + eventType);
	    });
	
	    var shotSelectors = [];
	    if (periods.length !== 0 && events.length !== 0) {
	        _.each(periods, function(p) {
	            _.each(events, function(e) {
	                shotSelectors.push(selectorBase + p + e);
	            });
	        });
	    }
	
	    if (shotSelectors.length) {
	        $(shotSelectors.join(',')).show();
	    }
	};
	
	var updatePeriodStats = function (selections) {
	    if (!selections) {
	        selections = getPeriodSelections();
	    }
	
	    $('.shooting-stats .home, .shooting-stats .away').each(function () {
	        var $this = $(this),
	            total = 0;
	        _.each(selections, function (value, period) {
	            if (value) {
	                var shots = $this.data('period' + period);
	                if (shots) {
	                    total += shots;
	                }
	            }
	        });
	        $(this).text(total);
	    });
	};
	
	var updateShootingMap = function () {
	    var periodSelections = getPeriodSelections(),
	        eventSelections = getEventSelections(),
	        playerId = getPlayerSelection();
	
	    toggleShots(periodSelections, eventSelections, playerId);
	    updatePeriodStats(periodSelections);
	};
	
	var updatePeriodSelection = function (e) {
	    e.preventDefault();
	    $(this).toggleClass('checked');
	    updateShootingMap();
	};
	
	var updateEventSelection = function (e) {
	    e.preventDefault();
	    $(this).toggleClass('checked');
	    updateShootingMap();
	};
	
	var getPeriodSelections = function () {
	    var result = {};
	    $('.button[data-period]').each(function () {
	        var checked = $(this).hasClass('checked');
	        result[$(this).data('period')] = checked;
	    });
	    return result;
	};
	var getEventSelections = function () {
	    var result = {};
	    $('.button[data-event]').each(function () {
	        var checked = $(this).hasClass('checked');
	        result[$(this).data('event')] = checked;
	    });
	    return result;
	};
	
	var setPeriodSelections = function (selections) {
	    $('.button[data-period]').each(function () {
	        var $this = $(this);
	        var checked = (selections[$this.data('period')] !== false);
	        $this.toggleClass('checked', checked);
	    });
	};
	
	var getPlayerSelection = function () {
	    return $('select[name=shooting-player-filter]').val();
	};
	
	var setPlayerSelection = function (id) {
	    $('select[name=shooting-player-filter]').val(id);
	};
	
	var updatePlayerSelection = function () {
	    updateShootingMap();
	};
	
	
	
	lightbox()
	var updateGameReport = function () {
	    window.setTimeout(function () {
	        if ($('#page .stats > .video').length) {
	            // We have a video, don't update anymore because the
	            // video would be overwritten
	            return;
	        }
	        // If div with game-finished class is within the code of the game tracking template,
	        //stop updating the page.
	        if($('.game-finished').length){
	
	            return;
	        }
	        // Prevent update, when lightbox is visible
	        if($('.video-home').is(':visible')){
	            updateGameReport();
	            return;
	        }
	        if($('.video-away').is(':visible')){
	            updateGameReport();
	            return;
	        }
	
	
	
	        var url = window.location.pathname + 'ajax';
	        $.ajax({
	            type: 'GET',
	            url: url,
	            cache: false
	        }).done(function (html) {
	            var savedPeriodSelections = getPeriodSelections(),
	                savedPlayerSelection = getPlayerSelection();
	
	            $('#page .stats').html(html);
	
	            setPeriodSelections(savedPeriodSelections);
	            setPlayerSelection(savedPlayerSelection);
	            updateShootingMap();
	
	            // Initialize the video if we have one
	            manualRuutuEmbed();
	
	            updateGameReport();  // Update again
	
	            lightbox()
	
	
	        });
	    }, 30000);
	
	};
	
	$(function () {
	    var sidebar = $('.sidebar-games'),
	        date = sidebar.data('date');
	
	    // Update sidebar every 30 sec
	    gameTracking({
	        el: sidebar,
	        date: date,
	        updateInterval: 30000,
	        link: 'report'
	    });
	
	    // initialize video
	    manualRuutuEmbed();
	
	    // Update the game report via AJAX periodically
	    updateGameReport();
	
	    $('#page').on('click mouseover touchstart', '.shot', showTooltip);
	    $('#page').on('mouseout', '.shot', hideTooltip);
	    $('#page').on('click', '.button.period', updatePeriodSelection);
	    $('#page').on('click', '.button.event', updateEventSelection);
	    $('#page').on('change', 'select[name=shooting-player-filter]', updatePlayerSelection);
	    $('#page').on('click', '.stats .head .status i, .stats .head .status-reverse i', function() {
	        $('html').toggleClass('reverse-time');
	        if (Modernizr.localstorage) {
	            localStorage.setItem('reverseTime', ''+$('html').hasClass('reverse-time'));
	        }
	    });
	});


/***/ })

});


// WEBPACK FOOTER //
// site/game-report.8d04218393a6ad56cf09.js